/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetJobConfigDto } from './GetJobConfigDto';
import {
    GetJobConfigDtoFromJSON,
    GetJobConfigDtoFromJSONTyped,
    GetJobConfigDtoToJSON,
} from './GetJobConfigDto';
import type { GetTeamDto } from './GetTeamDto';
import {
    GetTeamDtoFromJSON,
    GetTeamDtoFromJSONTyped,
    GetTeamDtoToJSON,
} from './GetTeamDto';

/**
 * 
 * @export
 * @interface GetJobConfigTeamDto
 */
export interface GetJobConfigTeamDto {
    /**
     * 
     * @type {string}
     * @memberof GetJobConfigTeamDto
     */
    id: string;
    /**
     * 
     * @type {GetJobConfigDto}
     * @memberof GetJobConfigTeamDto
     */
    jobConfig: GetJobConfigDto;
    /**
     * 
     * @type {GetTeamDto}
     * @memberof GetJobConfigTeamDto
     */
    team: GetTeamDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetJobConfigTeamDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetJobConfigTeamDto interface.
 */
export function instanceOfGetJobConfigTeamDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "jobConfig" in value;
    isInstance = isInstance && "team" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetJobConfigTeamDtoFromJSON(json: any): GetJobConfigTeamDto {
    return GetJobConfigTeamDtoFromJSONTyped(json, false);
}

export function GetJobConfigTeamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetJobConfigTeamDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'jobConfig': GetJobConfigDtoFromJSON(json['jobConfig']),
        'team': GetTeamDtoFromJSON(json['team']),
        'active': json['active'],
    };
}

export function GetJobConfigTeamDtoToJSON(value?: GetJobConfigTeamDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'jobConfig': GetJobConfigDtoToJSON(value.jobConfig),
        'team': GetTeamDtoToJSON(value.team),
        'active': value.active,
    };
}

